import i18n from "@/services/i18n";
export default {
    filters: {
        formatPrice(price, extra, fixed = 0) {
            //https://gist.github.com/lokeb/785b3a1ad9c90e984ea4ddb61ced3066
            price = Number(price).toFixed(fixed);
            let appendStr = "\u00A0" + "\u20BD";
            if(!extra && i18n.locale != "ru")
                extra = 'USD';
            if(extra == 'USD')
                appendStr = "\u00A0" + '\u0024';
            return (
                Number(price)
                    .toLocaleString("ru")
                    .toString()
                    .replace(".", ",") +
                    appendStr
            );
        }
    }
}